const config = data => key => {
    if ( key in data ) {
        return data[ key ];
    }
};

/**
 * Checks whether a specific feature is enabled.
 */
const isEnabled = data => feature => ( data.features && !! data.features[ feature ] ) || false;

export default data => {
    const configApi = config( data );
    configApi.isEnabled = isEnabled( data );

    return configApi;
};
